import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useProjectsTableSort = () => {
  const { t } = useTranslation('projects');

  return useMemo(
    () => [
      {
        label: t('type'),
        value: 'projectType',
      },
      {
        label: t('name'),
        value: 'projectName',
      },
      {
        label: t('dataSets'),
        value: 'dataSets',
        disabled: true,
      },
      {
        label: t('createdOn'),
        value: 'createdOn',
      },
      {
        label: t('createdBy'),
        value: 'createdBy',
      },
      {
        label: t('status'),
        value: 'active',
      },
    ],
    [t],
  );
};

export default useProjectsTableSort;
